const getters = {
  listaArquivosAssinados: (state) => state.listaArquivosAssinados,
  arquivoAssinadoBlobURL: (state) => state.arquivoAssinadoBlobURL,
  arquivoAssinadoInsercaoDialog: (state) => state.arquivoAssinadoInsercaoDialog,
  listaTiposAssinatura: (state) => state.listaTiposAssinatura
}

export default getters
